import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type OrganizationRoutes = {
    organization: Route
    organizationClient: Route
}

export const organizationRoutes: OrganizationRoutes = {
    organization: {
        path: 'dashboard/organization',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.organization.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-organization-details/page-organization-details.component').then(
                (m) => m.PageOrganizationDetailsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'invitations',
            },
            {
                path: 'invitations',
                canActivate: [
                    permissionGuard([PERMISSIONS.invite.read], {
                        redirectTo: ['/dashboard/organization'],
                    }),
                ],
                loadComponent: () =>
                    import('../../main/organization-permission/invitations/invitations-content.component').then(
                        (m) => m.InvitationsContentComponent,
                    ),
            },
            {
                path: 'permission',
                canActivate: [
                    permissionGuard([PERMISSIONS.role.read], {
                        redirectTo: ['/dashboard/organization'],
                    }),
                ],
                loadComponent: () =>
                    import('@baboor/baboor-group').then(
                        (m) => m.PermissionsContentComponent,
                    ),
            },
            {
                path: 'roles',
                pathMatch: 'full',
                redirectTo: 'permission',
            },
            {
                path: 'documents',
                canActivate: [
                    permissionGuard([PERMISSIONS.document.read], {
                        redirectTo: ['/dashboard/organization'],
                    }),
                ],
                loadComponent: () =>
                    import('../page-documents/page-documents.component').then(
                        (m) => m.PageDocumentsComponent,
                    ),
            },
            {
                path: 'subscriptions-usages',
                canActivate: [
                    permissionGuard([PERMISSIONS.subscription.read], {
                        redirectTo: ['/dashboard/organization'],
                    }),
                ],
                loadComponent: () =>
                    import('../page-subscription-usages/page-subscription-usages.component').then(
                        (m) => m.PageSubscriptionUsagesComponent,
                    ),
            },
            {
                path: 'subscribe-plan/:id',
                canActivate: [
                    permissionGuard([PERMISSIONS.subscription.write], {
                        redirectTo: ['/dashboard/organization'],
                    }),
                ],
                loadComponent: () =>
                    import('@baboor/baboor-subscription').then(
                        (m) => m.SubscribePlanComponent,
                    ),
            },
            {
                path: 'subscribe-plan-widget/:id',
                canActivate: [
                    permissionGuard([PERMISSIONS.subscription.write], {
                        redirectTo: ['/dashboard/organization'],
                    }),
                ],
                loadComponent: () =>
                    import('@baboor/baboor-plan').then(
                        (m) => m.PlanDowngradeWarningComponent,
                    ),
            },
            {
                path: 'downgrade-warning',
                canActivate: [
                    permissionGuard([PERMISSIONS.subscription.write], {
                        redirectTo: ['/dashboard/organization'],
                    }),
                ],
                loadComponent: () =>
                    import('@baboor/baboor-plan').then(
                        (m) => m.PlanDowngradeWarningComponent,
                    ),
            },
        ],
    },
    organizationClient: {
        path: 'dashboard/client/organization',
        canActivate: [authGuard({ redirectTo: ['/login'] })],
        loadComponent: () =>
            import('../page-organization-details/page-organization-details.component').then(
                (m) => m.PageOrganizationDetailsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.ClientDefault) },
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'invitations',
            },
            {
                path: 'invitations',
                canActivate: [
                    permissionGuard([PERMISSIONS.invite.read], {
                        redirectTo: ['/dashboard/client/organization'],
                    }),
                ],
                loadComponent: () =>
                    import('../../main/organization-permission/invitations/invitations-content.component').then(
                        (m) => m.InvitationsContentComponent,
                    ),
            },
            {
                path: 'permission',
                canActivate: [
                    permissionGuard([PERMISSIONS.role.read], {
                        redirectTo: ['/dashboard/client/organization'],
                    }),
                ],
                loadComponent: () =>
                    import('@baboor/baboor-group').then(
                        (m) => m.PermissionsContentComponent,
                    ),
            },
            {
                path: 'roles',
                pathMatch: 'full',
                redirectTo: 'permission',
            },
        ],
    },
}
